import { createMuiTheme } from "@material-ui/core/styles";

// background colors
const SP_PAPER_BACKGROUND = "#303749";
const SP_PRIMARY_BACKGROUND = "#252a38";
const SP_DARK_BACKGROUND = "#1d212d";
const SP_TRANSPARENT_OVERLAY = "rgba(255,255,255,0.10)";
const SP_SIDEBAR_SELECTED = "#4e576c";

const SP_RED = "#e2231a";

// font styles
const SP_PRIMARY_MAIN_COLOR = "#ffffff";
const SP_PRIMARY_DARK_COLOR = "#A8ACB7";
const SP_PRIMARY_BLACK = "#000000";
const SP_CARD_HEADER_COLOR = "#CBCED9";
const SP_ROW_SELECTED = "#4f576b";

// Buttons
const SP_BUTTON_BLUE = "#819cfd";
const SP_BUTTON_STRONG_BLUE = "#0076D9";

// Dividers
const SP_DIVIDER_GRAY = "#444B5B";

// Icon colors
const SP_STATUS_WARNING = "#FFCA19";
const SP_STATUS_FAILED = "#A10014";
const SP_STATUS_ACTIVE = "#81D135";
const SP_SLIDER_THUMB_CHECKED = "#0076D9";
const SP_SLIDER_TRACK_CHECKED = "#0C5691";

export const spTheme = {
  navSpacingSize: 9,
  palette: {
    type: "dark",
    primary: {
      main: SP_PRIMARY_BACKGROUND,
      dark: SP_DARK_BACKGROUND,
      red: SP_RED,
      button: SP_BUTTON_BLUE,
      divider: SP_DIVIDER_GRAY,
      graph: ["#819cfd", "#7e5bbf", "#cbd7fa", "#58e2c2", "#B39DDB"],
    },
    secondary: {
      main: SP_RED,
    },
    background: {
      default: SP_PRIMARY_BACKGROUND,
      selected: SP_ROW_SELECTED,
      paper: SP_PAPER_BACKGROUND,
      dark: SP_DARK_BACKGROUND,
      overlay: SP_TRANSPARENT_OVERLAY,
      blue: SP_BUTTON_BLUE,
      hover: "#DF4740",
      sidebarSelected: SP_SIDEBAR_SELECTED,
      disabled: "rgba(130,135,145, 0.3)",
      chips: {
        selected: "#4d5977",
        deselected: "#2b3140",
      },
      timeline: "#424A5E",
      buttons: {
        blue: SP_BUTTON_BLUE,
        strongBlue: SP_BUTTON_STRONG_BLUE,
      },
    },
    border: {
      primary: SP_PRIMARY_MAIN_COLOR,
    },
    text: {
      primary: SP_PRIMARY_MAIN_COLOR,
      secondary: SP_PRIMARY_DARK_COLOR,
      black: SP_PRIMARY_BLACK,
      blue: SP_BUTTON_BLUE,
      lightgrey: SP_CARD_HEADER_COLOR,
      red: SP_RED,
    },
    statusIcons: {
      active: SP_STATUS_ACTIVE,
      warning: SP_STATUS_WARNING,
      failed: SP_STATUS_FAILED,
    },
    statusColors: {
      reserved: SP_BUTTON_BLUE,
      unavailable: "#A70D0D",
      out_of_service: "#A70D0D",
      available: "#00E676",
      offline: "#828791",
      fault: "#828791",
      firmware_update: SP_STATUS_WARNING,
      operator: SP_STATUS_WARNING,
      self_check: SP_STATUS_WARNING,
      charging: SP_STATUS_WARNING,
      mismatched: "#FF00FF",
    },
    geofencesTypeColors: {
      is_operational_zone: "#346DF1",
      warehouse: "#2D9C42",
      no_parking_zone: "#A140FD",
      no_riding_zone: "#FF564B",
      no_scooter_zone: "#850003",
      slow_riding_zone: "#EDB727",
      no_parking_slow_zone: "#7764B4",
      allow_parking_zone: "#26F7F8",
      limited_parking_zone: "#26F7F8",
      parking_incentive_zone: "#26F7F8",
    },
  },
  mapbox: {
    dark: "mapbox://styles/spmatt/cjkla668967482rpl5ijaj103",
  },
  typography: {
    fontSize: 14,
    letterSpacing: 0.15,
    body2: {
      fontSize: 14,
    },
    h1: {
      fontSize: 104,
      fontWeight: 100,
    },
    h2: {
      fontSize: 60,
      fontWeight: 100,
      color: "#ffffff",
    },
    h3: {
      fontSize: 48,
      fontWeight: 300,
    },
    h4: {
      fontSize: 34,
      fontWeight: 300,
    },
    caption: {
      fontSize: 12,
    },
    button: {
      fontSize: 14,
      fontWeight: 300,
    },
    title: {
      fontWeight: 100,
    },
  },
  overrides: {
    MuiTypography: {
      h5: {
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: 0.15,
        lineHeight: "24px",
        color: SP_CARD_HEADER_COLOR,
      },
      body2: {
        fontsize: 16,
      },
    },
    MuiSlider: {
      track: { backgroundColor: SP_RED },
      thumb: { backgroundColor: SP_RED },
    },
    MuiInput: {
      underline: {
        "&::before": {
          display: "none",
        },
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        // borderColor: SP_PRIMARY_MAIN_COLOR,
      },
      root: {
        "&$focused $notchedOutline": {
          borderColor: SP_PRIMARY_MAIN_COLOR,
        },
      },
    },
    MuiInputLabel: {
      outlined: {
        "&$shrink": {
          color: "rgba(130,135,145, 0.8)",
        },
        "&$focused": {
          color: SP_PRIMARY_MAIN_COLOR,
        },
        "&$disabled": {
          color: "rgba(130,135,145, 0.3)",
        },
      },
    },
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "none",
        },
      },
    },
    MuiSwitch: {
      switchBase: {
        // Controls default (unchecked) color for the thumb
        color: "#ccc",
      },
      colorSecondary: {
        "&$checked": {
          // Controls checked color for the thumb
          color: SP_SLIDER_THUMB_CHECKED,
        },
      },
      track: {
        // Controls default (unchecked) color for the track
        backgroundColor: SP_PRIMARY_BLACK,
        "$checked$checked + &": {
          // Controls checked color for the track
          backgroundColor: SP_SLIDER_TRACK_CHECKED,
        },
      },
    },
  },
};

export default createMuiTheme(spTheme);
